import FormSystemError from '../../../utils/form-error-constants';
import Tooltip from '../tooltip';

class AddressBook {
    init() {
        this.formErrorConstants = new FormSystemError('form.addressForm');

        this.formErrorConstants.init();
        this.handleEvents();
        this.scrollToEditForm();
        this.saveAddress();
        this.editEmail();
    }

    handleEvents() {
        $('.addressForm .inputText').keypress(({target}) => {
            this.removeErrorDiv(target);
        });

        $('form.addressForm').on('change', '#nbr, #zip', ({target}) => {
            let $accountForm = $(target).closest("form");
            let zipCode = $accountForm.find('[name="zip"]').val();
            let number = $accountForm.find('[name="nbr"]').val();
            let $street = $accountForm.find('[name="street"]');
            let $city = $accountForm.find('[name="city"]');
            let country = $accountForm.find('[name="country"]').val();

            if (country === 'Nederland') {
                this.loadAddress(
                    zipCode,
                    number,
                    $street,
                    $city,
                );
            }
        });

        $('.addressContainer .editAddress').on('click', ({target}) => {
            this.toggleEdit(target);
        });

        /*$('input[name="defaultBilling"]').on('click', (event) => {
            $(event.target).closest('.group').find('#default-address-notice').toggleClass('hidden');
        });*/

        $('.addressContainer .deleteAddress').on('click', (event) => {
            let addressContainer = $(event.target).closest('.addressContainer');
            let isAllowToDelete = true;

            addressContainer.find('form [type="checkbox"]').each(function (i, element) {
                if ($(element).data('checked')) {
                    isAllowToDelete = false;
                }
            });

            if (!isAllowToDelete) {
                addressContainer.find('.default-delete-notice').removeClass('hidden');

                return false;
            }

            if (confirm('Weet je het zeker?')) {
                this.deleteAddress($(event.target));
            }
        });
    }

    editEmail() {
        let self = this;
        let $emailInput = $('.formField input[name="email"]');

        $emailInput.focusout(function() {
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let value = $emailInput.val();

            if (!regex.test(value)) {
                self.formErrorConstants.hideNoticeErrorNext($emailInput.parents('.column'), $emailInput.parent('.formField'));
                self.formErrorConstants.showNoticeErrorAfter($emailInput.parents('.column'), $emailInput.parent('.formField'), self.formErrorConstants.constants.email);
            } else {
                self.formErrorConstants.hideNoticeErrorNext($emailInput.parents('.column'), $emailInput.parent('.formField'));
            }
        });

    }

    scrollToEditForm() {
        if (window.location.href.indexOf('#edit-') > 0 && (window.location.href.search('errorKey') > 0)) {
            let addrId = window.location.href.split('#edit-')[1];
            let anchorTable = document.querySelector('.addressContainer[data-id="' + addrId + '"]');

            if (anchorTable) {
                $("html, body").animate({scrollTop: anchorTable.offsetTop + 150}, 1000);
                this.toggleEdit(anchorTable);
            }
        }
    }

    toggleEdit(target) {
        let addressContainer = $(target).closest('.addressContainer');
        addressContainer.find('.addressBlock').toggleClass('hidden');
        addressContainer.find('.addressFormBlockContainer').toggleClass('hidden');
    }

    saveAddress() {
        let self = this;
        let tooltip = new Tooltip();
        tooltip.init();
        let $form = $('form.addressForm');

        $form.on('click', '.check-form', {}, (event) => {
            let allowSendForm = true;
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            event.preventDefault();

            let $form = $(event.target).closest('form.addressForm');
            self.formErrorConstants.removeErrors($form);
            self.formErrorConstants.removeDataError($form);

            $form.find('input').not(':button, :hidden').each(function (i, element) {
                let errorMessage = $(element).data('error-message');
                let $element = $(element);

                if (errorMessage) {
                    if ($element.attr('required')) {
                        let value = $element.val();

                        if (!value || !value.length) {
                            allowSendForm = false;
                            $element.attr('data-error', errorMessage);
                            if (typeof self.formErrorConstants.constants[$element.attr('name')] !== "undefined") {
                                $element.attr('data-error', $element.attr('name'));
                            }
                        }
                    }

                    if ($element.attr('type') === 'email') {
                        if (value && !regex.test(value)) {
                            allowSendForm = false;
                            $element.attr('data-error', 'email');
                            $element.val(null);
                        }
                    }

                    if ($element.attr('latin') && self.formErrorConstants.hasLatinSymbols($element) ) {
                        allowSendForm = false;
                        $element.attr('data-error', self.formErrorConstants.constants.latin);
                        $element.val(null);
                    }
                }
            });

            if (!allowSendForm) {
                self.formErrorConstants.init();

                return false;
            }
            
            $form.submit();

            return false;
        });
    }

    deleteAddress(element) {
        $.ajax({
            type: 'POST',
            url: '/?action=addressBook/deleteAddress',
            context: this,
            data: {id: element.data('id')}
        })
            .done((data) => {
                element.closest('.addressContainer').remove();
            }).fail(() => {
                console.log('Something wrong was happened');
            });
    }

    loadAddress(zipCode, number, $street, $city) {
        if (!zipCode.length || !number.length) {
            return;
        }

        zipCode = zipCode.replace(/\s/g, '');

        $.getJSON(`/?action=ajax/getAddress&zipcode=${zipCode}&number=${number}`)
            .done((data) => {
                if (data.street) {
                    $street.val(data.street);
                }
                if (data.city) {
                    $city.val(data.city);
                }
            });
    }

    removeErrorDiv(element) {
        let errorDiv = $(element).closest('.group').find('.notice-error');

        if (errorDiv.length) {
            errorDiv.remove();
            $(element).closest('.column').removeClass('error');
        }
    }
}

$(document).ready(function () {
    let addressBook = new AddressBook();

    addressBook.init();
});
